import React, { useCallback, useContext } from 'react';
import { LanguageContext } from '../../shared/contexts/Language.context';
import { ThemeContext } from '../../shared/contexts/Theme.context';
import BookingHolderData from '../BookingHolderData/BookingHolderData';
import GuestAdvice from '../GuestAdvice/GuestAdvice';
import GuestListType from '../GuestListType/GuestListType';
import styles from './StartCheckinPage.style';
import isMobile from 'ismobilejs';
import CustomIcon from '../CustomIcon/CustomIcon';
import { notification } from 'antd';
import CustomButton from '../CustomButton/CustomButton';

const onlyAdults = 'all_adults';

export default function GuestList({ state, actions }) {
  const { state: theme } = useContext(ThemeContext);
  const { className: themeClassName, styles: themeStyle } = styles(theme);
  const {
    actions: { translate },
  } = useContext(LanguageContext);

  const { adults = [], children = [] } = getGuestsByType();
  const handleClick = useCallback(
    guestId => {
      if (guestId) actions.handleGuestCheckin(guestId);
    },
    [actions]
  );
  const { disabled, from, to } = state.checkinDisabled || {};
  const isMobileDevice = isMobile().any;

  return (
    <>
      <div className={`${themeClassName} hotel-name-container`}>
        <h1 className={`${themeClassName} hotel-name`}>{theme.name}</h1>
      </div>
      {state.showHolderData ? <BookingHolderData bookings={[state.bookingToCheckin]} /> : null}
      {isMobileDevice && (
        <div className={`${themeClassName} share-root`}>
          <div className={`${themeClassName} share-container`} onClick={() => share(translate)}>
            <p className={`${themeClassName} share-text`}>{translate('share')}</p>
            <CustomIcon size={20} type={'share'} color={theme.mainColor}></CustomIcon>
          </div>
        </div>
      )}

      <GuestAdvice adviceKey={'start-checkin'} />
      {adults.length ? (
        <GuestListType
          guests={adults}
          type={'adults'}
          onClick={handleClick}
          booking={state.bookingToCheckin}
          disabled={disabled}
        />
      ) : null}
      {children.length ? (
        <GuestListType
          guests={children}
          type={'children'}
          onClick={handleClick}
          booking={state.bookingToCheckin}
          disabled={disabled}
        />
      ) : null}

      {state.bookingToCheckin.bookingCompletedActionUrl && (
        <div className={`${themeClassName} booking-completed-action`}>
          <CustomButton
            text={'Acción booking'}
            onClick={() => window.open(state.bookingToCheckin.bookingCompletedActionUrl)}
          ></CustomButton>
        </div>
      )}

      {disabled ? (
        <div>
          {translate('bookingSearchForm.notAvailable')
            .replace(
              '{from}',
              from?.replace('days', translate('days')).replace('hours', translate('hours'))
            )
            .replace(
              '{to}',
              to?.replace('days', translate('days')).replace('hours', translate('hours'))
            )}
        </div>
      ) : null}
      {themeStyle}
    </>
  );

  function getGuestsByType() {
    const res = { adults: [], children: [] };
    state?.checkinRequirements?.checkinGuests?.forEach(guest => {
      let attr = null;
      if (guest.type === 'adult') attr = 'adults';
      else if (
        guest.type === 'child' &&
        state?.checkinRequirements.requiredCheckinData != onlyAdults
      ) {
        attr = 'children';
      }
      if (attr) res[attr].push(guest);
    });
    return res;
  }
}

async function share(translate) {
  try {
    await navigator.share({ url: window.location.href });
  } catch (err) {
    copyUrlToClipboard(translate);
  }
}

function copyUrlToClipboard(translate) {
  var dummy = document.createElement('input'),
    text = window.location.href;

  document.body.appendChild(dummy);
  dummy.value = text;
  dummy.select();
  document.execCommand('copy');
  document.body.removeChild(dummy);

  notification.success({
    message: translate('share.copied'),
  });
}
